import { ExtFile } from "./ExtFile";
import { Method } from "./method"

export type UploadConfig = {
    /**
     * The url endpoint to upload the file.
     * e.g. https://www.myasomwbackend/uploads/file
     */
    url?: string;
    /**
     * upload method, can be POST | PUT | PATCH
     * @default "POST"
     */
    method?: Method;
    /**
     * Request headers for http request.
     * e.g.
     * ```jsx
     * headers = { 
     *    "content-type": "multipart/form-data",
     *    Authorization: "Bearer YOUR_BEARER_TOKEN_GOES_HERE",
     * } 
     * ```
     */
    headers?: Record<string, string>;
    /**
     * the label to use in request
     * On server this must be the label to get the file.
     * @default "file"
     */
    uploadLabel?: string;
    /**
     * Flag for indicating whther to remove the non-valid files
     * before starting the upload process.
     * This flag is valid only if validation is enable
     */
    cleanOnUpload?: boolean;
    /**
     * If true, onDrop event or file selection not only will make Dropzone to return the list of files, but also
     * it will start the upload stage for the files if at least url was set
     * By default is false
     */
    autoUpload?: boolean;
    /**
     * The time that will last the "preparing" stage
     * By default is 1500 miliseconds = 1.5 seconds
     */
    preparingTime?: number;
    /**
     * A message to show in the footer when the uploading process takes place.
     */
    uploadingMessage?: string;
    /**
     * A function to generate the upload url given an ExtFile
     */
    urlFromExtFile?: (f: ExtFile) => string;
    /**
     * If true, the file will be uploaded as blob rather than FormData
     * @default false
     */
    asBlob?: boolean;
    /**
     * If true, the file will be uploaded in chunks
     * @default false
     */
    //chunk?: boolean;
    /**
     * If given, the file will be uploaded in chunks. Also the size of each chunk will be this value in megabytes.
     * @default undefined
     */
    chunkSize?: number;
    /**
     * If given, the file will be uploaded in chunks. Also the number of chunks will be this value in megabytes.
     * @default undefined
     */
    numberOfChunks?: number;
}

export const createUploadConfig = (
    url?: string,
    method?: Method,
    headers?: Record<string, string>,
    uploadLabel?: string,
    cleanonUpload?: boolean
) => {
    return {
        url,
        method,
        headers,
        uploadLabel,
        cleanonUpload
    }
}